import script from "./rate-pie.vue?vue&type=script&lang=ts&setup=true"
export * from "./rate-pie.vue?vue&type=script&lang=ts&setup=true"

import "./rate-pie.vue?vue&type=style&index=0&id=0586a58e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0586a58e"]])

export default __exports__